<template>
<div>xiangq</div>
</template>

<script>
export default {
  name: 'Det'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/customer-service/det.vue